import Header from "./components/Header/Header"
import Hero from "./components/Hero/Hero"
import EmotionalSection from "./components/EmotionalSection/EmotionalSection"
import CategoriesSection from "./components/CategoriesSection/CategoriesSection"
import WhyDreamsSection from "./components/WhyDreamsSection/WhyDreamsSection"
import InspirationGallery from "./components/InspirationGallery/InspirationGallery"
import HowItWorks from "./components/HowItWorks/HowItWorks"
import FeaturedSuppliers from "./components/FeaturedSuppliers/FeaturedSuppliers"
import PromotionsSection  from "./components/PromotionsSection/PromotionsSection"
import ProviderCTA from "./components/ProviderCTA/ProviderCTA"
import Testimonials from "./components/Testimonials/Testimonials"
import FinalCTA from "./components/FinalCTA/FinalCTA"
import Footer from "./components/Footer/Footer"
import WhatsappFloat from "./components/WhatsappFloat/WhatsappFloat"

function App() {
  return (
    <>
      <Header />
      <Hero />
      <EmotionalSection />
      <CategoriesSection />
      <WhyDreamsSection />
      <InspirationGallery />
      <HowItWorks />
      <FeaturedSuppliers />
      <PromotionsSection />
      <ProviderCTA />
      <Testimonials />
      <FinalCTA />
      <Footer />
      <WhatsappFloat />
    </>
  )
}

export default App